import { render, staticRenderFns } from "./message-notificator.vue?vue&type=template&id=39b1c8ae"
import script from "./message-notificator.vue?vue&type=script&lang=js"
export * from "./message-notificator.vue?vue&type=script&lang=js"
import style0 from "./message-notificator.vue?vue&type=style&index=0&id=39b1c8ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports